import React, { useRef } from 'react'
import { ZdsIconButton, ZdsTextAreaField } from '@zera/components'
import { Form } from './styles'

interface OpenQuestion {
  onSend: (question: string) => void
  disabled: boolean
}

export const OpenQuestion = ({ disabled, onSend }: OpenQuestion): JSX.Element => {
  const textAreaRef = useRef<HTMLTextAreaElement>(null)

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const userQuestion = e.target['customQuestion']?.value?.trim()
    if (userQuestion) {
      onSend(userQuestion)
      e.currentTarget.reset()
      e.target['customQuestion'].blur()
    }
  }

  const submitOnEnter = (e: React.KeyboardEvent<HTMLFormElement>) => {
    if (e.key === 'Enter' && e.ctrlKey) {
      e.preventDefault()
      e.currentTarget.dispatchEvent(new Event('submit', { bubbles: true }))
    }
  }

  const calculateTextAreaHeightDynamic = () => {
    if (textAreaRef.current) {
      textAreaRef.current.style.height = 'auto'
      textAreaRef.current.style.height = `${textAreaRef.current.scrollHeight}px`
    }
  }

  return (
    <Form onSubmit={handleSubmit} onKeyDown={submitOnEnter}>
      <ZdsTextAreaField
        ref={textAreaRef}
        name="customQuestion"
        rows={1}
        maxLength={Infinity}
        style={{ maxHeight: '150px', minHeight: '51px' }}
        showCounter={false}
        disableTrim
        placeholder="Ou digite aqui sua pergunta"
        disabled={disabled}
        onChange={calculateTextAreaHeightDynamic}
      />
      <ZdsIconButton src="MiSendMessage" type="submit" disabled={disabled} />
    </Form>
  )
}
